module.exports = __webpack_public_path__ + "img/download-app.e3a6df64.svg";